import Marquee from "react-fast-marquee";

const items = [
  "Hair Artistry",
  "Nail Studio",
  "Facials & Skin",
  "Waxing & Threading",
  "Henna Art",
  "Ladies Only",
  "Bur Dubai",
];

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-section"
      className="py-10 sm:py-14 border-y border-line overflow-hidden marquee-fade"
    >
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif italic font-light text-4xl sm:text-6xl text-bone/90 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-2xl sm:text-3xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
